import React, { useState } from "react";
import { ERCText } from "components/text";
import { useLocation } from "react-router-dom";
import { MdDateRange, MdAccessTimeFilled } from "react-icons/md";
import YoutubeEmbed from "components/dashboard/home/YoutubeEmbed";

export const EventDetails = () => {
  const [activeVideoId, setActiveVideoId] = useState(null);
  const location = useLocation();
  const { eventData } = location.state || {}; // Retrieve the passed data
  console.log(eventData, "eventData");
  const extractYouTubeVideoId = (url) => {
    const regex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  return (
    <div className="flex flex-col gap-12 p-8 w-full">
      {/* Image Section */}
      <div className=" md:h-[509px] w-full">
        <img
          src={eventData.thumbnail}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content Section */}
      <div className="flex flex-col gap-12  w-full">
        {/* Event Description */}
        <div className="flex flex-col gap-4.5">
          <ERCText size="22px" weight="600" lHeight="24px">
            {eventData.name}
          </ERCText>
          <ERCText
            color="#3D3D3D"
            align="justify"
            size="16px"
            weight="400"
            lHeight="24px"
          >
            {eventData.description}
          </ERCText>
        </div>

        {/* Date and Time */}
        <div className="flex gap-12 items-start">
          <div className="flex gap-3 items-center ">
            <MdDateRange size={24} color="black" />
            <ERCText size="18px" weight="700">
              {eventData.date.split("T")[0]}
            </ERCText>
          </div>
          <div className="flex gap-3 items-center ">
            <MdAccessTimeFilled size={24} color="black" />
            {/* <ERCText size='18px' weight='700'>{eventData.time}</ERCText> */}
            <p className="text-[16px] text-black ">
              {eventData.startTime} - {eventData.endTime}
            </p>
          </div>
          {/* Location Block */}
          <div className="flex items-start gap-3 mt-4">
            <strong className="text-[16px] text-black">Location:</strong>
            {eventData.capacity === "Online " ? (
              <div className="flex flex-col">
                <button
                  className="text-blue-600 underline text-[14px] w-fit"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveVideoId(extractYouTubeVideoId(eventData.location));
                  }}
                >
                  Join Online Event {eventData.location}
                </button>
                {activeVideoId ===
                  extractYouTubeVideoId(eventData.location) && (
                  <YoutubeEmbed embedId={activeVideoId} />
                )}
              </div>
            ) : (
              <p className="text-[16px] text-gray-700">{eventData.location}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
